export default __webpack_public_path__ + "static/media/6955a56f840077ec9289ebdd3a50824d.jpg";